import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaintRoller, faHammer, faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "../Styles/HomeServices.css";

function HomeServices() {
  const services = [
    {
      icon: faPaintRoller,
      title: "Drywall Painting",
      desc: "From small repairs to complete remodels. Premium paints with flawless finishes that transform your space beautifully.",
      link: "/services/drywall-painting"
    },
    {
      icon: faHammer,
      title: "Demolition Repair",
      desc: "Removing damaged drywall and replacing with new materials. Seamless patches that restore walls to perfection.",
      link: "/services/demolition-repair"
    },
    {
      icon: faCircleMinus,
      title: "Popcorn Removal",
      desc: "Modernize your ceilings. Professional texture removal for smooth, contemporary finishes that elevate your home.",
      link: "/services/popcorn-removal"
    },
  ];

  return (
    <section className="hs-section">
      <div className="hs-inner">
        <div className="hs-header">
          <span className="section-label">WHAT WE DO</span>
          <h2>Our Core Services</h2>
          <p>
            Professional stucco and drywall solutions with precision and
            quality that stands the test of time.
          </p>
        </div>

        <div className="hs-grid">
          {services.map((service, idx) => (
            <div className="hs-card" key={idx}>
              <div className="hs-card-icon">
                <FontAwesomeIcon icon={service.icon} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <Link to={service.link} className="hs-card-link">Learn More →</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeServices;
